import { APIcaller } from './APIcaller';

const checkPennylanePartnerInvoicePrerequisites = ({ centralKitchenIssuerRef, orderIds }) =>
  APIcaller.apiPost('/partner-invoice/check-prerequisites', { centralKitchenIssuerRef, orderIds });

const generatePennylanePartnerInvoices = ({ centralKitchenIssuerRef, orderIds, groupByStore }) =>
  APIcaller.apiPost('/partner-invoice/generate', {
    centralKitchenIssuerRef,
    orderIds,
    groupByStore,
  });

const fetchCentralKitchenStoreIdsWithPennylane = () =>
  APIcaller.apiGet('/partner-invoice/store-pennylane-status');

const fetchClientPennylaneStatus = () =>
  APIcaller.apiGet('/partner-invoice/client-pennylane-status');

const checkPennylaneOrdersPrerequisites = ({ orderIds }) =>
  APIcaller.apiPost('/partner-invoice/orders/check-prerequisites', { orderIds });

const generatePennylaneOrdersInvoices = ({ orderIds, groupByStore }) =>
  APIcaller.apiPost('/partner-invoice/orders/generate', { orderIds, groupByStore });

export default {
  checkPennylanePartnerInvoicePrerequisites,
  generatePennylanePartnerInvoices,
  fetchCentralKitchenStoreIdsWithPennylane,
  fetchClientPennylaneStatus,
  checkPennylaneOrdersPrerequisites,
  generatePennylaneOrdersInvoices,
};
